<template>
  <div class="case-box">
    <div class="bgPic" id="topBox">
      <div class="picText">
        <p class="title">全渠道、多平台、多业态融合</p>
        <br />
        <span>以顾客为中心，助力企业实现数字化转型</span>
      </div>
      <!-- <div class="pic">
        <img
          src="@/assets/last/bg/关于我们背景.png"
          alt=""
          style="height: 870px; width: 100%"
        />
      </div> -->
    </div>
    <!-- ..................... -->
    <div class="middle" id="user1">
      <h1>关于我们</h1><br><br><br>
      <div class="four">
        <div class="left">
          <img src="../assets/last/certificate/关于我们图片.png" alt="" />
        </div>
        <div class="right">
          <h2>企业介绍</h2>
          <p>
             深圳泽润数字软件运营有限公司（以下简称泽润软件）成立于<br>2025年6月，专注于软件技术开发，业务聚焦零售业数字化运<br>
             营，全渠道运营以及软件产品与服务等领域，致力于解决数字<br>化时代的企业管理及运营，高效低本的供应链管理新渠道销售 ，<br>
             强大的信息化平台助力企业敏捷、高效、稳步前进。现服务多<br>家知名公司新零售运营实施、咨询，以及数字化转型项目。
          </p>
        </div>
      </div>
    </div>
    <div class="middle middle2" id="user2">
      <div class="five">
        <div class="left">
          <h2>企业文化</h2>
          <p>我们的使命：致力于为客户提供数字化解决方案 成为顾客信赖的伙伴。</p>
          <p>
            我们的愿景：成为经得起时间考验的一流企业 价值观行为准则：高效 、卓越
            、职业化
          </p>
          <div class="footer">
            <div class="prise">
              <span>2025</span><br />
              <i>公司成立于</i>
            </div>
            <div class="prise">
              <span>74%</span><br />
              <i>研发人员占比</i>
            </div>
            <div class="prise">
              <span>40%</span><br />
              <i>专业优秀人才</i>
            </div>
          </div>
        </div>
        <div class="right">
          <img src="../assets/last/企业文化图片.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 图二 -->
    <div class="services-box">
      <!-- <img src="../assets/last/bg/数字化营销服务商背景.png" alt="" /> -->
      <div class="services">
        <div class="services-txt">
          <span>数字化营销服务商</span><br />
          <p>数字化营销方案服务商：数据+智能-帮助企业高效实践数字化增长</p>
        </div>
        <div class="services-sup">
          <div><span>服务支持</span></div>
          <div><span>技术支持</span></div>
          <div><span>数据支持</span></div>
        </div>
      </div>
    </div>
    <!-- 知识产权 -->
    <!-- <div class="certificat-box">
      <img src="../assets/last/certificate/获得多项只是产权证书.png" alt="" />
    </div> -->
    <!-- 信息安全管理 -->
    <!-- <div class="safe-box">
      <h1>信息安全管理</h1>
      <div class="safe">
        <div class="safe-left">
          <p>ISO27001信息安全管理体系认证</p>
        </div>
        <div class="safe-right">
          <p>信息安全三级等级保护认证</p>
        </div>
      </div>
    </div> -->
    <div class="foote" id="user3">
      <div class="first" style="text-align: center; padding-top: 30px">
        <h1>合作伙伴</h1>
        <img src="../assets/last/合作伙伴logo.png" alt="" style="height: 500px" />
      </div>
    </div>
    <!-- <div class="foot"></div> -->
     <BottomFooter />
  </div>
</template>

<script>
import BottomFooter from './bottom.vue'
export default {
  name: "User",
  components: {
    BottomFooter
  },
  props: {
    point: {
      type:String,
      default:''
    }
  },
  data() {
    return {
      bannerHeight: 500,
    };
  },
  watch: {
    point: {
      handler(newVal) {
        if(newVal){
          this.getScoll(newVal)
              console.log('新新新',newVal);
          }
      },
      immediate: true
    }
  },
  mounted() {},

  methods: {
     // 滚动
    getScoll(point){
      this.$nextTick(() => {
        // 元素自身高度
        const height = document.getElementById(point).offsetHeight
        const scrollTop = (document.getElementById(point).offsetTop)-(height/2) // 获取需要滚动的距离
        document.documentElement.scrollTop = scrollTop 
      })
    }
  },
};
</script>

<style lang="less" scoped>
.bgPic {
  background: url("../assets/last/bg/关于我们背景.png") no-repeat;
  background-size: cover;
//   height: 870px;
  height: 75vh;
  min-height: 800px !important;
  position: relative;
}
.picText {
  color: rgb(242, 243, 247);
  text-align: center;
  letter-spacing: 3px;
  line-height: 50px;
  font-family: SourceHanSansCN-Regular-;
//   padding-top: 250px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-80%);
  .title {
    display: inline-block;
    font-size: 50px;
    font-weight: normal;
    letter-spacing: 7px;
  }

  span {
    font-size: 35px;
  }
  :hover{
      color: rgba(110, 87, 229);
    }
}
// ....
.middle {
  margin-top: 100px;
  padding-bottom: 100px;
  text-align: center;
  // border-bottom: 1px dotted #999;
}
.four {
  // padding-top: 10px;
  margin: auto;
  width: 70%;
  display: flex;
  justify-content: center;
  text-align: center;

  .left {
    width: 50%;
    margin-right: 65px;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .right {
    width: 50%;
    font-size: 22px;
    text-align: left;
    line-height: 40px;
    color: #666666;
    padding: 10px;
    background-color: rgb(248, 248, 248);
    h2 {
      padding-right: 10px;

      text-align: right;
      color: #1c1c25;
    }
    span {
      color: rgb(76, 132, 255);
    }
  
      :hover{
        color: rgb(71, 136, 173);
      }
      p{
        text-align: justify;        /* 两端对齐 */
  text-align-last: justify;   /* 最后一行也撑满 */
      }
  
  }
}
.middle2 {
  padding-top: 100px;
  background-color: rgb(248, 248, 248);
}
.five {
  margin: auto;
  width: 70%;
  display: flex;
  justify-content: center;
  text-align: center;
  line-height: 40px;
  padding-bottom: 100px;
  .left {
    width: 50%;
    font-size: 22px;
    padding-left: 10px;
    text-align: left;
    color: #666666;
    h2 {
      color: #1c1c25;
    }
    span {
      color: rgb(76, 132, 255);
    }
    :hover{
      color: rgb(113, 183, 223);
    }
    
  }
  .right {
    width: 50%;
    margin-left: 65px;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .footer {
    height: 120px;
    display: flex;
    justify-content: space-between;
    .prise {
      // font-size: 25px;
      flex: 1;
      text-align: center;
      span {
        color: rgb(76, 132, 255);
      }
      i {
        font-style: normal;
      }
      :hover{
      font-size: 32px;
      }
    }
  }
  // ....
  .foote {
    text-align: center;
    .first {
      width: 1000px;
      border-bottom: 1px dotted #999;
    }
  }
}
//
.services-box {
  //  background: url("../assets/last/bg/关于我们背景.png") no-repeat;

  background: url("../assets/last/bg/数字化营销服务商背景.png") no-repeat;
  background-size: cover;
  height: 700px;
  text-align: center;
  color: #fff;
  .services {
    padding-top: 100px;
    text-align: center;
    .services-txt {
      letter-spacing: 3px;
      span {
        font-size: 50px;
      }
      p {
        font-size: 25px;
      }
    }
    .services-sup {
      display: flex;
      justify-content: center;
      div {
        margin: 50px;
        position: relative;
        width: 200px;
        height: 200px;
        border-radius: 100px;
        font-size: 40px;
        background-color: rgb(58, 106, 255);
        span {
          display: block;
          position: absolute;
          top: 22%;
          left: 25%;
          width: 100px;
          height: 100px;
        }
      }
      :hover{
        font-weight: 600;
        color: rgb(66, 69, 81);
      }
    }
    :hover{
        font-weight: 600;
        color: rgb(100, 122, 189);
      }
  }
}
.certificat-box {
  text-align: center;
  background-color: rgb(241, 243, 248);
  img {
    // height: 700px;
    width: 100%;
  }
}
.safe-box {
  margin-top: 100px;
  border-bottom: 1px dotted #999;

  h1 {
    padding-bottom: 50px;
  }
  text-align: center;
  .safe {
    margin: 50px auto 0;
    width: 70%;
    display: flex;
    justify-content: space-between;
    background-color: #fff;

    .safe-left {
      background: url("../assets/last/certificate/ISO27001信息安全管理体系认证.png")
        no-repeat;
      background-size: contain;
      flex: 1;
      height: 500px;
      margin-right: 50px;
      position: relative;

      p {
        font-size: 22px;
        position: absolute;
        top: -60px;
        left: 50%;
        transform: translate(-50%);
        white-space: nowrap;
      }
    }

    .safe-right {
      background: url("../assets/last/certificate/等保三级证书.png") no-repeat;
      background-size: 90%, auto;

      flex: 1;
      margin-left: 50px;

      height: 500px;
      position: relative;

      p {
        font-size: 22px;
        position: absolute;
        top: -60px;
        left: 50%;
        transform: translate(-50%);
        white-space: nowrap;
      }
    }

    img {
      height: 50vh;
    }
  }
}

//    .foot{
//     background: url("../assets/last/bg/底部.png") no-repeat;
//     background-size: contain;
//     height: 480px;
//   }
</style>